"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Accounting = function Accounting(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.5,11a6.5,6.5,0,1,0,6.5,6.5A6.51,6.51,0,0,0,17.5,11Zm-2.28,6.57a.6.6,0,0,1,.84,0l.85.85V14.36a.59.59,0,0,1,.59-.59.58.58,0,0,1,.59.59v4.07l.85-.85a.6.6,0,0,1,.84,0A.63.63,0,0,1,20,18a.58.58,0,0,1-.17.41l-.12.13-1.74,1.73a.6.6,0,0,1-.84,0l-1.86-1.86,0,0a.58.58,0,0,1-.15-.39A.63.63,0,0,1,15.22,17.58Zm4.53,4.21h-4.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.5a.5.5,0,0,1,.5.5A.5.5,0,0,1,19.75,21.79Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14,9.51a.5.5,0,0,0-.5-.5h-8a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h8A.5.5,0,0,0,14,9.51Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,11.51A.5.5,0,0,0,12,11H5.5a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5H12A.5.5,0,0,0,12.5,11.51Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11,13.51a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h5A.5.5,0,0,0,11,13.51Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.5,15a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5H10a.5.5,0,0,0,.5-.5A.5.5,0,0,0,10,15Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.5,6h10a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5H12a2.5,2.5,0,0,0-4.9,0H4.5a.5.5,0,0,0-.5.5v3A.5.5,0,0,0,4.5,6Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,4.51V10a7.08,7.08,0,0,1,2,.13V2.51a.5.5,0,0,0-.5-.5H16V4h.5A.5.5,0,0,1,17,4.51Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.51,22h-9a.5.5,0,0,1-.5-.5v-17A.5.5,0,0,1,2.5,4H3V2H.5a.5.5,0,0,0-.5.5v21a.5.5,0,0,0,.5.5H13.77A7.6,7.6,0,0,1,11.51,22Z",
    fill: "#004864"
  }));
};

var _default = Accounting;
exports["default"] = _default;